import React, { useState, useEffect } from "react";
import MUIDataTable from "mui-datatables";
import { formatDateTime, isoToSqlDate } from "../../../helpers/helpers";
import { CircularProgress } from "@mui/material";
import Form from "../../../components/form";
import ijws from "../../../services/ijws";
import modalidadeAssinatura from "../../../enums/modalidadeAssinatura";

let dataAtual = new Date();
let dataAnterior = new Date();
dataAnterior.setMonth(dataAnterior.getMonth() - 1);

const PreCadastros = ({ match, history }) => {
  const [carregando, setCarregando] = useState(false);
  const [registros, setRegistros] = useState([]);
  const [filtros, setFiltros] = useState({
    dataInicio: isoToSqlDate(dataAnterior.toISOString()),
    dataFim: isoToSqlDate(dataAtual.toISOString()),
    assinantesAtivos: false,
  });
  const [totais, setTotais] = useState({
    preCadastros: 0,
    cadastros: 0,
    assinaturas: 0,
    percCadastros: 0,
    percAssinaturas: 0,
  });

  useEffect(() => {
    carregarRelatorio();
  }, []);

  const carregarRelatorio = (novosFiltros = filtros) => {
    setCarregando(true);
    setFiltros(novosFiltros);

    ijws.get("admin/relatorios/cadastros", novosFiltros).then((registros) => {
      const qtdCadastros = registros.length;
      const qtdAssinaturas = registros.filter((r) => r.dataAssinatura).length;
      const qtdAssinaturasCanceladas = registros.filter(
        (r) => r.dataAssinatura && r.assinaturaCancelada
      ).length;
      const qtdAssinaturasAtivas = qtdAssinaturas - qtdAssinaturasCanceladas;

      let totalDiasAssinaturasAtivas = 0;
      let totalDiasAssinaturasCanceladas = 0;

      registros.forEach((r) => {
        r.dataCadastro = formatDateTime(r.dataCadastro, "D/M/Y h:m");
        r.preCadastroDataHora = r.preCadastroDataHora
          ? formatDateTime(r.preCadastroDataHora, "D/M/Y h:m")
          : "";
        r.dataAssinatura = r.dataAssinatura
          ? formatDateTime(r.dataAssinatura, "D/M/Y h:m")
          : "";
        r.ultimoAcesso = r.ultimoAcesso
          ? formatDateTime(r.ultimoAcesso, "D/M/Y h:m")
          : "-";
        r.modalidadeAssinatura = modalidadeAssinatura.desc(
          r.modalidadeAssinatura
        );

        if (r.assinaturaAtiva === 1) r.situacaoAssinatura = "Ativa";
        if (r.assinaturaCancelamento) r.situacaoAssinatura = "Cancelada";
        if (r.assinaturaSuspensa) r.situacaoAssinatura = "Suspensa";
        if (
          !r.assinaturaAtiva &&
          !r.assinaturaCancelamento &&
          !r.assinaturaSuspensa
        )
          r.situacaoAssinatura = "Vencida";
      });

      const totais = {
        cadastros: qtdCadastros,
        assinaturas: qtdAssinaturas,
        percAssinaturas: ((qtdAssinaturas / qtdCadastros) * 100).toFixed(0),
      };

      setRegistros(registros);
      setCarregando(false);
      setTotais(totais);
    });
  };

  // const definirSituacaoRegistro = (registro, dataAtual) => {
  //   if (!registro.inicio) {
  //     if (new Date(registro.previsaoInicio) < dataAtual) return "Atrasado";
  //     return "Não iniciado";
  //   }
  //   if (!registro.termino) return "Em andamento";
  //   return "Finalizado";
  // };

  const gerarFiltros = (filtros) => {
    return {
      dataInicio: {
        label: "Cadastrado a partir de ",
        type: "date",
        space: 5,
        value: filtros.dataInicio,
      },
      dataFim: {
        label: "Cadastrado até",
        type: "date",
        space: 5,
        value: filtros.dataFim,
      },
      assinantesAtivos: {
        label: "Apenas assinantes ativos",
        type: "check",
        space: 2,
        value: filtros.assinantesAtivos,
      },
    };
  };

  const formTotais = (totais) => {
    return {
      cadastros: {
        label: "Cadastros",
        type: "text",
        space: 6,
        value: totais.cadastros,
        readOnly: true,
      },
      assinaturas: {
        label: "Assinaturas",
        type: "text",
        space: 6,
        value: `${totais.assinaturas} (${totais.percAssinaturas} %)`,
        readOnly: true,
      },
    };
  };

  const columns = [
    {
      name: "usuarioNome",
      label: "Nome",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "usuarioEmail",
      label: "Email",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "usuarioTelefone",
      label: "Telefone",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "dataCadastro",
      label: "Cadastro",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "preCadastroDataHora",
      label: "Pré-cadastro",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "dataAssinatura",
      label: "Assinatura",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "situacaoAssinatura",
      label: "Situação da assinatura",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "modalidadeAssinatura",
      label: "Modalidade da assinatura",
      options: {
        filter: false,
        sort: false,
      },
    },
  ];

  const options = {
    filterType: "checkbox",
    selectableRows: "none",
    rowsPerPage: 50,
    downloadOptions: {
      filename: "cadastros.csv",
      separator: ";",
      filterOptions: {
        useDisplayedColumnsOnly: false,
        useDisplayedRowsOnly: true,
      },
    },
  };

  const fFiltros = {
    title: "Filtros",
    form: gerarFiltros(filtros),
    submit: {
      label: "Carregar",
      action: carregarRelatorio,
    },
  };

  const fTotais = {
    title: "Totais",
    form: formTotais(totais),
  };

  return (
    <div>
      <Form formData={fFiltros} />
      <Form formData={fTotais} />

      {carregando ? (
        <CircularProgress />
      ) : (
        <MUIDataTable
          title="Inglês Juntos - Cadastros"
          data={registros}
          columns={columns}
          options={options}
        />
      )}
    </div>
  );
};

export default PreCadastros;
